import { put, call, takeEvery } from 'redux-saga/effects';

import { filter$ as filterQueued$ } from 'redux/modules/queued/effects';
import { filter$ as filterJobs$ } from 'redux/modules/jobs/effects';

import { setFilter, COMMON_FILTERS_STORAGE } from './duck';

function* handlePersistFilters({ payload }) {
  const { filters } = payload;

  if (filters) {
    yield call(persistFilters, filters);
    return;
  }
  yield call(persistFilters, payload);
}

function* persistFilters(filters) {
  if (!filters) {
    return;
  }

  const { routes, date, range_date, shipper, xDock } = filters;

  try {
    const filtersToPersist = { routes, date, range_date, shipper, xDock };
    yield put(setFilter(filtersToPersist));
    localStorage.setItem(COMMON_FILTERS_STORAGE, JSON.stringify(filtersToPersist));
  } catch (err) {
    console.error(err);
  }
}

// Watchers
export function* watchCommon() {
  yield takeEvery([filterQueued$, filterJobs$], handlePersistFilters);
}
